module.exports = __webpack_public_path__ + "static/media/forgotpwd.19c96820.svg";